import { FormEngineFormView } from '@gov-nx/component/web';
import { useSmartFormContext } from '@gov-nx/module/service';

export const SmartForm = () => {
	const { ...formEngineFormViewProps } = useSmartFormContext();

	return <FormEngineFormView {...formEngineFormViewProps} />;
};
